<template>
  <div id="app">
    <AppHeader />
    <router-view />
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './components/Header.vue'
import AppFooter from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Microsoft YaHei', -apple-system, sans-serif;
}
body {
  background: #f0f2f5;
}
#app {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 0 24px 10px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.06);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
router-view {
  flex: 1;
}
</style>